import { apiFetch } from './apiFetch'
import { API_BASE_URL } from './apiBaseUrl'

type ExecuteCapabilityRequest = {
  app: string
  capability: string
  input?: any
}

export async function executeCapability<T = any>(req: ExecuteCapabilityRequest): Promise<T> {
  const token = localStorage.getItem('lts_jwt_token')
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }

  const r = await apiFetch(`${API_BASE_URL}/capabilities/execute`, {
    method: 'POST',
    headers,
    body: JSON.stringify(req),
  })

  const payload = await r.json()
  if (!r.ok || !payload?.success) {
    throw new Error(payload?.message || 'Capability execution failed')
  }

  return payload.data as T
}

